<div
  class="segmented-bar"
  [class.segmented-bar--slim]="size === 'slim'"
  role="img"
  [attr.aria-label]="ariaLabel || null"
>
  <span
    *ngFor="let segment of rendered"
    class="segmented-bar__segment"
    [class]="'segmented-bar__segment segmented-bar__segment--' + segment.tone"
    [style.width.%]="segment.widthPercent"
  ></span>
</div>
